import { render } from "./lazyLoadImage.vue?vue&type=template&id=ae83aba0&ts=true"
import script from "./lazyLoadImage.vue?vue&type=script&lang=ts"
export * from "./lazyLoadImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__